import React from "react";
import Header from "../../Header/Navbar";
import Footer from "../../Footer/Footer";
import CheckoutForm from "./CheckoutForm";

const Checkout = () => {
  return (
    <div>
      <Header />
      <CheckoutForm />
      <Footer />
    </div>
  );
};

export default Checkout;
